//WASH
import apiClientIMGMT from './apiClient'
import { APIEndpointsIMGMT } from './apiConfig'

const instMgmtApi = {
    init(accesToken) {
        apiClientIMGMT.initClients(accesToken)
    },
    async checkWashIsInstalled() {
        try {
            let status = await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washInstallcheck
            )
            return status
        }
        catch (e) {
            console.error('Failed to check if WASH is installed:', e)
        }
        return false
    },
    async checkWashIsInitialized() {
        try {
            let status = await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washInitcheck
            )
            return status
        }
        catch (e) {
            console.error('Failed to check if WASH is initialized:', e)
        }
        return false
    },
    async getWashJobs(stationId) {
        return await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washJobs(stationId)
            )
    },
    async updateWashJobs(data) {
        return await apiClientIMGMT.postJson(
                APIEndpointsIMGMT.washJobs(), data
            )
    },
    async getWashStations() {
        return await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washStations()
            )
    },
    async getWashStation(id) {
        return await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washStations(id)
            )
    },
    async getWashServices() {
        return await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washServices
            )
    },
    async getWashSalesTypes() {
        return await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washSalestypes
            )
    },
    async getWashReportJobTypes() {
        return await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washReportJobTypes
            )
    },
    async getWashSettings() {
        return await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washSettings
            )
    },
    async updateWashSettings(settingsObj) {
        return await apiClientIMGMT.postJson(
                APIEndpointsIMGMT.washSettings, settingsObj
            )
    },
    async getScanCodeInfo(scancode) {
        return await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washScanCode(scancode)
            )
    },
    async getWashOpenJobsForScanCode(scancode, stationId) {
        return await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washOpenJobsForScanCode(scancode, stationId)
            )
    },
    async postScanCodeAction(scancode, data) {
        return await apiClientIMGMT.postJson(
                APIEndpointsIMGMT.washScanCode(scancode), data
            )
    },
    async getOpenWashItemsCounter() {
        return await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washOpenItemsCounter
            )
    },
    async getOpenWashItems() {
        return await apiClientIMGMT.getJson(
                APIEndpointsIMGMT.washOpenItems
            )
    },
    async clearOpenWashItems() {
        return await apiClientIMGMT.postJson(
                APIEndpointsIMGMT.washOpenItems
            )
    }
}
export default instMgmtApi